import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'
import Box, { BoxProps } from '@mui/material/Box'
import { Dialog, DialogActions } from '@mui/material'

import { useTranslation } from 'react-i18next'

import Icon from 'src/@core/components/icon'

import { useMentorCloud } from 'src/contexts/MentorCloudContext'

import MentorCloud from 'src/pages/courses/media-storage'

import { MentorCloudFileExtension } from 'src/types/files/file'

const IconBox = styled(Box)<BoxProps>(({ theme }) => ({
  position: 'absolute',
  top: `-${theme.spacing(2.5)}`,
  right: `-${theme.spacing(2.5)}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 32,
  height: 32,
  padding: theme.spacing(1.5),
  borderRadius: theme.spacing(1.5),
  backgroundColor: theme.palette.customColors.cardBg,
  boxShadow: `0 2px 4px 0 ${theme.colorWithOpacity(theme.palette.grey[500], 30)}`,
  cursor: 'pointer'
}))

type MentorcloudModalProps = {
  isOpen: boolean
  mediaType: MentorCloudFileExtension
  onChoose: () => void
  onClose: () => void
  onCancel: () => void
}

const MentorCloudModal = ({ isOpen, mediaType, onChoose, onClose, onCancel }: MentorcloudModalProps) => {
  const { t } = useTranslation()

  const { files } = useMentorCloud()

  return (
    <Dialog
      maxWidth='xl'
      fullWidth
      PaperProps={{
        sx: { overflow: 'visible', position: 'relative' }
      }}
      open={isOpen}
      onClose={onClose}
    >
      <IconBox>
        <Icon icon='tabler:x' onClick={onClose} />
      </IconBox>
      <MentorCloud isModal={true} type={mediaType} />
      <DialogActions>
        <Button variant='tonal' onClick={onCancel}>
          {t('ACTION.cancel')}
        </Button>
        <Button variant='contained' color='primary' disabled={files?.length === 0} onClick={onChoose}>
          {t('extracted.choose_selected')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default MentorCloudModal
